module.exports = __webpack_public_path__ + "static/media/shiro.731ec810.png";